import { requestMembersOnline } from 'helpers/web_to_client'

export const MEMBERS_ONLINE_START = 'clan_members_online/MEMBER_ONLINE_START'
export const MEMBERS_ONLINE_SUCCESS = 'clan_members_online/MEMBERS_ONLINE_SUCCESS'
export const MEMBERS_ONLINE_ERROR = 'clan_members_online/MEMBER_ONLINE_ERROR'


export function startRequest() {
    return {
        type: MEMBERS_ONLINE_START,
        payload: {},
    }
}

export function requestSuccess(respData) {
    return {
        type: MEMBERS_ONLINE_SUCCESS,
        payload: {
            members_online: respData.online_members,
            members_total: respData.all_members,
        },
    }
}

export function requestError() {
    return {
        type: MEMBERS_ONLINE_ERROR,
        payload: {},
    }
}

export default function requestMembersStatus() {
    return async (dispatch, getState) => {
        if (getState().clanMembersOnline.loading) return
        dispatch(startRequest())

        try {
            const respData = await requestMembersOnline()
            dispatch(requestSuccess(respData))
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error('>> WGSH cannot request members status', e)
            dispatch(requestError())
        }

        setTimeout(requestMembersStatus, 15000)
    }
}



// WEBPACK FOOTER //
// ./state/actions/clan_members_online.js